import "./Kontakt.css";
import {Avatar, Grid, Link, Typography} from "@mui/material";
import imgVorstand from "../images/kontakt_bilder/volker.jpg"
import imgAlex from "../images/kontakt_bilder/alex.png"
import imgUli from "../images/kontakt_bilder/uli.jpg"
import * as React from "react";
import SectionHeading from "../components/SectionHeading";

const imageStyle = {
    width: 80,
    height: 80,
    '@media (min-width: 600px)': {
        width: 130,
        height: 130,
    },
}

function Kontakt() {
    const vorstandEmail = '1.vorstand@musikverein-wissgoldingen.de';
    const vorstandEmailLink = `mailto:${vorstandEmail}`;
    const vorstandTel = "07162 / 941241"
    const vorstandTelLink = `tel:${vorstandTel}`
    const dirigentEmail = 'dirigent@musikverein-wissgoldingen.de';
    const dirigentEmailLink = `mailto:${dirigentEmail}`;
    const jugendEmail = 'alexhoran@arcor.de';
    const jugendEmailLink = `mailto:${jugendEmail}`;
    const jugendMobile = "0151 / 68193110"
    const jugendMobileLink = `tel:${jugendMobile}`

    return (
        <div className="kontakt_outer">
            <SectionHeading>Kontakt</SectionHeading>
            <Grid container className="kontakt_inner">
                <Grid item xs="4" className="avatar_wrapper">
                    <Avatar
                        alt="Avatar image"
                        src={imgVorstand}
                        sx={imageStyle}
                    />
                </Grid>
                <Grid item xs="8" className="text_wrapper">
                    <div>
                        <Typography variant="h4">
                            1. Vorstand: Volker Pitzal
                        </Typography>
                        <Typography>
                            Uhlandstraße 21
                        </Typography>
                        <Typography>
                            73550 Wißgoldingen
                        </Typography>
                        <Typography>
                            <strong>Mail: </strong>
                            <Link href={vorstandEmailLink} color="inherit">
                                {vorstandEmail}
                            </Link>
                        </Typography>
                        <Typography>
                            <strong>Telefon: </strong>
                            <Link href={vorstandTelLink} color="inherit">
                                {vorstandTel}
                            </Link>
                        </Typography>
                    </div>
                </Grid>
                <Grid item xs="4" className="avatar_wrapper">
                    <Avatar
                        alt="Avatar image"
                        src={imgUli}
                        sx={imageStyle}
                    />
                </Grid>
                    <Grid item xs="8" className="text_wrapper">
                        <div>
                            <Typography variant="h4">
                                Dirigent: Ulrich Allgaier
                            </Typography>
                            {/*
                            <Typography>
                                <strong>Mail: </strong>
                                <Link href={dirigentEmailLink} color="inherit">
                                    {dirigentEmail}
                                </Link>
                            </Typography>
                            */}
                        </div>
                    </Grid>
                <Grid item xs="4" className="avatar_wrapper">
                    <Avatar
                        alt="Avatar image"
                        src={imgAlex}
                        sx={imageStyle}
                    />
                </Grid>
                <Grid item xs="8" className="text_wrapper">
                    <div>
                        <Typography variant="h4">
                            Jugendleiter: Alex Horan
                        </Typography>
                        <Typography>
                            Am Rackerzeil 4
                        </Typography>
                        <Typography>
                            73550 Waldstetten
                        </Typography>
                        <Typography>
                            <strong>Mail: </strong>
                            <Link href={jugendEmailLink} color="inherit">
                                {jugendEmail}
                            </Link>
                        </Typography>
                        <Typography>
                            <strong>Mobil: </strong>
                            <Link href={jugendMobileLink} color="inherit">
                                {jugendMobile}
                            </Link>
                        </Typography>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default Kontakt;